import Icon from './img/Link_Icon.png';

export const UrlInput = ({ url }) => {
    if (url !== "") {
        return (
            <div className="social-icon" style={{ marginTop: '0.5rem' }}>
                <a href={url} target="_blank" rel="noopener noreferrer"><img src={Icon} alt="GitHub icon" /></a>
            </div>
        )
    }
}
